__turbopack_context__.v({
  "FilterItems": "FilterItems-module__HAkmCq__FilterItems",
  "accordion": "FilterItems-module__HAkmCq__accordion",
  "accordionItem": "FilterItems-module__HAkmCq__accordionItem",
  "chevron": "FilterItems-module__HAkmCq__chevron",
  "description": "FilterItems-module__HAkmCq__description",
  "filterItem": "FilterItems-module__HAkmCq__filterItem",
  "icon": "FilterItems-module__HAkmCq__icon",
  "item": "FilterItems-module__HAkmCq__item",
  "items": "FilterItems-module__HAkmCq__items",
  "moreText": "FilterItems-module__HAkmCq__moreText",
  "text": "FilterItems-module__HAkmCq__text",
  "title": "FilterItems-module__HAkmCq__title",
  "value": "FilterItems-module__HAkmCq__value",
});
